import { uiActions } from "store";
import { FiservDataGrid, FiservDataGridType } from "types";

export const getFiservDataGridMessages = (
	grids: FiservDataGridType,
	applicationNumber: string,
): { successMessages: string[]; errorMessages: string[] } => {
	const successMessages: string[] = [];
	const errorMessages: string[] = [];

	Object.keys(grids)?.forEach(id => {
		if (grids[id] === null) {
			if (id !== FiservDataGrid.UserDefinedGridFiserv.name) {
				errorMessages.push(FiservDataGrid.getByName(id)?.error || "");
			}
		} else {
			successMessages.push(
				`${FiservDataGrid.getByName(id)?.displayName} ${
					grids[id]
				} is applied for Application ${applicationNumber}`,
			);
		}
	});

	return { successMessages, errorMessages };
};

export const showFiservDataGridMessages = (
	grids,
	applicationNumber,
	dispatch,
): void => {
	if (!grids) return;
	const { successMessages, errorMessages } = getFiservDataGridMessages(
		grids,
		applicationNumber,
	);

	if (successMessages?.length > 0) {
		dispatch(
			uiActions.showSuccessNotification({
				title: successMessages.join("\r\n"),
				delay: 5000,
			}),
		);
	}
	if (errorMessages?.length > 0) {
		errorMessages.forEach(message => {
			dispatch(
				uiActions.showErrorNotification({
					title: message,
					delay: 5000,
				}),
			);
		});
	}
};
